/**
 * Capture First Name and Last Name
 * Also capture the username and check availability
 * */
import { Form } from '@remix-run/react'
import { Input } from "~/components/ui/input"
import { Button } from "~/components/ui/button"
import {Label} from "~/components/ui/label";
import { useState } from 'react'
import { EyeIcon, EyeOffIcon } from "lucide-react"

interface Props {
    errorMessage?: string
    errorFields?: Array<string>
    defaultValues?: {
        email: string
        password: string
        confirmPassword: string
    }
}
const EmailPassword = ({ errorMessage, errorFields, defaultValues }: Props) => {
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    
    return (
        <div className={"flex flex-col gap-6 w-full max-w-sm"} >
            <h3 className={'bold mb-6 text-2xl text-white'}>Create account</h3>
            <Form method={'post'}>
                <input type="hidden" name="_action" value="submit-emailPassword" />
                <div className="flex flex-col gap-6">
                    <div className="grid gap-3">
                        <Label htmlFor="email">Email address</Label>
                        <Input
                            id="email"
                            name="email"
                            type="email"
                            placeholder="Enter your email"
                            required
                            defaultValue={defaultValues?.email}

                        />
                        {errorFields?.includes('email') && (<p className='text-sm p-2 text-red-300'>{errorMessage}</p>)}
                    </div>

                    <div className="grid gap-3">
                        <Label htmlFor="password">Password</Label>
                        <div className="relative">
                            <Input
                                id="password"
                                name="password"
                                type={showPassword ? "text" : "password"}
                                placeholder="Enter your password"
                                required
                                defaultValue={defaultValues?.password}
                                className="pr-10"
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 focus:outline-none"
                            >
                                {showPassword ? (
                                    <EyeOffIcon className="h-4 w-4" />
                                ) : (
                                    <EyeIcon className="h-4 w-4" />
                                )}
                            </button>
                        </div>
                        {errorFields?.includes('password') && (<p className='text-sm p-2 text-red-300'>{errorMessage}</p>)}
                    </div>

                    <div className="grid gap-3">
                        <Label htmlFor="confirmPassword">Confirm password</Label>
                        <div className="relative">
                            <Input
                                id="confirmPassword"
                                name="confirmPassword"
                                type={showConfirmPassword ? "text" : "password"}
                                placeholder="Confirm your password"
                                required
                                defaultValue={defaultValues?.confirmPassword}
                                className="pr-10"
                            />
                            <button
                                type="button"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 focus:outline-none"
                            >
                                {showConfirmPassword ? (
                                    <EyeOffIcon className="h-4 w-4" />
                                ) : (
                                    <EyeIcon className="h-4 w-4" />
                                )}
                            </button>
                        </div>
                        {errorFields?.includes('confirmPassword') && (<p className='text-sm p-2 text-red-300'>{errorMessage}</p>)}
                    </div>

                    <div className={'grid gap-3'}>
                        <div className={'mt-4'}>
                            <div className={'text-xs font-semibold text-gray-100'}>
                                Password Requirements:
                            </div>
                            <ul className={'text-xs text-gray-100'}>
                                <li>Must be at least 8 characters long</li>
                                <li>Must contain at least one number</li>
                                <li>Must contain at least one lowercase letter</li>
                                <li>Must contain at least one uppercase letter</li>
                            </ul>
                        </div>
                        <Button
                            type={'submit'}
                        >Continue</Button>
                    </div>
                </div>
            </Form>
        </div>
    )
}

export default EmailPassword
